var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0C6.2692 0 0 6.2692 0 14C0 21.7308 6.2692 28 14 28C21.7308 28 28 21.7308 28 14C28 6.2692 21.7308 0 14 0ZM20.3922 10.9157C20.3984 11.0535 20.4014 11.1919 20.4014 11.331C20.4014 15.5772 17.1693 20.4736 11.2586 20.4738H11.2588H11.2586C9.44385 20.4738 7.75516 19.9419 6.33307 19.0304C6.5845 19.0601 6.84042 19.0748 7.09955 19.0748C8.60516 19.0748 9.99072 18.5613 11.0907 17.6993C9.68396 17.6732 8.49792 16.7442 8.08862 15.4674C8.28452 15.505 8.48596 15.5255 8.69254 15.5255C8.98584 15.5255 9.26996 15.486 9.53998 15.4123C8.06961 15.1179 6.96198 13.8184 6.96198 12.2624C6.96198 12.2479 6.96198 12.2348 6.9624 12.2214C7.39542 12.4621 7.89059 12.607 8.41782 12.6232C7.55499 12.0475 6.98782 11.0633 6.98782 9.94843C6.98782 9.35968 7.14697 8.80811 7.42297 8.33322C9.00763 10.2776 11.3759 11.5564 14.0466 11.6907C13.9915 11.4553 13.963 11.2101 13.963 10.958C13.963 9.18408 15.4022 7.7449 17.1768 7.7449C18.1011 7.7449 18.936 8.13562 19.5224 8.76025C20.2545 8.61584 20.9419 8.34839 21.5629 7.98032C21.3226 8.73035 20.8133 9.35968 20.1498 9.75766C20.7998 9.6799 21.4193 9.50751 21.9951 9.25159C21.565 9.89609 21.0197 10.4622 20.3922 10.9157Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTwitter);
export default __webpack_public_path__ + "static/media/icon-twitter.ddce5c788ac5cad5027e042fcb079a8e.svg";
export { ForwardRef as ReactComponent };